export default __webpack_public_path__ + "static/media/intro-bg.be44c970.png";